import { Skeleton } from 'ui/skeleton';
import { DESTINATION_COLUMN_GRID } from './HeaderRow.styles';
import { SkeletonGridRow } from './SkeletonRow.styles';

export const SkeletonRow = ({
  skeletonColumnCount,
}: {
  skeletonColumnCount: number;
}) => (
  <SkeletonGridRow gridLayout={DESTINATION_COLUMN_GRID} data-test="table-loading">
    {[...Array(skeletonColumnCount)].map((_, i) => (
      <Skeleton key={i} height={50} shimmerSpeed={2500} />
    ))}
  </SkeletonGridRow>
);
